import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  fetchCurrentMenu,
  fetchCurrentMenuDetails
} from 'bento-ordering/menus/actions';

import { fetchLocationInventory } from 'bento-ordering/locations/actions/locationInventory';

import { fetchCartLocationThrottledTimes } from 'bento-ordering/locations/actions/locationThrottledTimes';

// if we refactor MenuContainer and CartContainer to be functional components, all this logic can just live in hooks and be instantiated in one of those components. until then, we keep this logic here

const MenuManager = () => {
  const dispatch = useDispatch();
  const { byLocationId } = useSelector(state => state.locationInventory);
  const { id: menuId, isError } = useSelector(state => state.menu);
  const {
    online_ordering_location: selectedLocation,
    online_ordering_fulfillment_method: selectedMethod,
    fulfillment_date: selectedDate,
    fulfillment_time: selectedTime,
    requested_fulfillment_is_asap: selectedAsap
  } = useSelector(state => state.cart);
  const hasAlreadyFetchedForLocation = Object.prototype.hasOwnProperty.call(
    byLocationId,
    selectedLocation
  );

  useEffect(() => {
    if (isError || !selectedLocation) {
      return;
    }

    dispatch(fetchCurrentMenu());
  }, [
    selectedAsap,
    selectedDate,
    selectedTime,
    selectedMethod,
    selectedLocation,
    menuId
  ]);

  useEffect(() => {
    if (menuId) {
      dispatch(fetchCurrentMenuDetails());
    }
  }, [menuId]);

  useEffect(() => {
    const shouldFetchLocationInventory =
      menuId && selectedLocation && !hasAlreadyFetchedForLocation;

    if (shouldFetchLocationInventory) {
      dispatch(fetchLocationInventory(selectedLocation));
    }
  }, [menuId, selectedLocation, hasAlreadyFetchedForLocation]);

  useEffect(() => {
    if (menuId) {
      dispatch(fetchCartLocationThrottledTimes());
    }
  }, [menuId]);

  return null;
};

export default withRouter(MenuManager);
